import { useCallback } from 'react';
import { useToastNotifications } from '@nbirl/nbi-common-ui-libs';

import { ApiError } from '../models';
import { getErrorCodeMessage } from '../utils';

export const useErrorToast = () => {
  const { addToast } = useToastNotifications();

  const showErrorToast = useCallback(
    (error: string | ApiError) => {
      return addToast({
        variant: 'danger',
        text: getErrorCodeMessage(error),
      });
    },
    [addToast]
  );

  return { showErrorToast };
};
